module.exports = "<p>Skapare: Aiman Josefsson</p>\n<p>2018</p>"